import {html} from 'lit';

export function videoExternal(videoUrl: string) {
  return html`
  <div class="externalembed__content-wrapper">
  <iframe class="video__content" allow="encrypted-media; accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture; payment" allowfullscreen frameborder="0" scrolling="no" loading="lazy" referrerpolicy="unsafe-url"
    src="${videoUrl}" sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation" width="600" height="400"></iframe>
  </div>
  `;
}
